{
	"languages": [
		{ "value": "en-US", "label": "English" },
		{ "value": "de-DE", "label": "Deutsch" },
		{ "value": "es-ES", "label": "Español" },
		{ "value": "fr-FR", "label": "Français" },
		{ "value": "it-IT", "label": "Italiano" },
		{ "value": "pl-PL", "label": "Polski" }
	],
	"brands": [
		{
			"name": "vw",
			"calcDomain": "VW.NEW",
			"markets": [
				{
					"name": "AUS",
					"ending": "au",
					"currency": "$",
					"currency_previous": "$",
					"currency_after": " AUS",
					"currency_decimal_positions": 2,
					"currency_grouping_separator": ",",
					"currency_decimal_separator": ".",
					"currency_show_digit_grouping": true,
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-aus.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-aus.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-aus.delivery.did.avp.tech",
						"vitals": "https://vw-aus.vitals.did.avp.tech"
					}
				},
				{
					"name": "CHE",
					"ending": "ch",
					"currency": "CHF",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-che.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-che.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-che.delivery.did.avp.tech",
						"vitals": "https://vw-che.vitals.did.avp.tech"
					}
				},
				{
					"name": "DEU",
					"ending": "de",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-deu.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-deu.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-deu.delivery.did.avp.tech",
						"vitals": "https://vw-deu.vitals.did.avp.tech"
					}
				},
				{
					"name": "ESP",
					"ending": "es",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-esp.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-esp.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-esp.delivery.did.avp.tech",
						"vitals": "https://vw-esp.vitals.did.avp.tech"
					}
				},
				{
					"name": "ESP (Canary Island)",
					"ending": "ic",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-ic.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-ic.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-ic.delivery.did.avp.tech",
						"vitals": "https://vw-ic.vitals.did.avp.tech"
					}
				},
				{
					"name": "FRA",
					"ending": "fr",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-fra.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-fra.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-fra.delivery.did.avp.tech",
						"vitals": "https://vw-fra.vitals.did.avp.tech"
					}
				},
				{
					"name": "GBR",
					"ending": "gb",
					"currency": "£",
					"currency_previous": "£",
					"currency_show_digit_grouping": true,
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-gbr.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-gbr.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-gbr.delivery.did.avp.tech",
						"vitals": "https://vw-gbr.vitals.did.avp.tech"
					}
				},
				{
					"name": "IRL",
					"ending": "ie",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-irl.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-irl.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-irl.delivery.did.avp.tech",
						"vitals": "https://vw-irl.vitals.did.avp.tech"
					}
				},
				{
					"name": "LUX",
					"ending": "lu",
					"currency": "€",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-lux.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-lux.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-lux.delivery.did.avp.tech",
						"vitals": "https://vw-lux.vitals.did.avp.tech"
					}
				},
				{
					"name": "NLD",
					"ending": "nl",
					"currency": "€",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-nld.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-nld.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-nld.delivery.did.avp.tech",
						"vitals": "https://vw-nld.vitals.did.avp.tech"
					}
				},
				{
					"name": "POL",
					"ending": "pl",
					"currency": "PLN",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-pol.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-pol.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-pol.delivery.did.avp.tech",
						"vitals": "https://vw-pol.vitals.did.avp.tech"
					}
				},
				{
					"name": "RSA",
					"ending": "za",
					"currency": "ZAR",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.vw-rsa.content.did.avp.tech",
					"urls": {
						"pairing": "https://vw-rsa.dealer.did.avp.tech/ssp",
						"delivery": "https://vw-rsa.delivery.did.avp.tech",
						"vitals": "https://vw-rsa.vitals.did.avp.tech"
					}
				}
			]
		},
		{
			"name": "audi",
			"calcDomain": "DID.AUDI.NEW.DE",
			"markets": [
				{
					"name": "AUS",
					"ending": "au",
					"currency": "$",
					"currency_previous": "$",
					"currency_after": " AUS",
					"currency_decimal_positions": 2,
					"currency_grouping_separator": ",",
					"currency_decimal_separator": ".",
					"currency_show_digit_grouping": true,
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-aus.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-aus.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-aus.delivery.did.avp.tech",
						"vitals": "https://audi-aus.vitals.did.avp.tech"
					}
				},
				{
					"name": "AUT",
					"ending": "at",
					"currency": "€",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-aut.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-aut.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-aut.delivery.did.avp.tech",
						"vitals": "https://audi-aut.vitals.did.avp.tech"
					}
				},
				{
					"name": "BRA",
					"ending": "br",
					"currency": "BRL",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-bra.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-bra.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-bra.delivery.did.avp.tech",
						"vitals": "https://audi-bra.vitals.did.avp.tech"
					}
				},
				{
					"name": "CHE",
					"ending": "ch",
					"currency": "CHF",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-che.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-che.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-che.delivery.did.avp.tech",
						"vitals": "https://audi-che.vitals.did.avp.tech"
					}
				},
				{
					"name": "DEU",
					"ending": "de",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-deu.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-deu.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-deu.delivery.did.avp.tech",
						"vitals": "https://audi-deu.vitals.did.avp.tech"
					}
				},
				{
					"name": "DNK",
					"ending": "dk",
					"currency": "DKK",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-dnk.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-dnk.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-dnk.delivery.did.avp.tech",
						"vitals": "https://audi-dnk.vitals.did.avp.tech"
					}
				},
				{
					"name": "ESP",
					"ending": "es",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-esp.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-esp.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-esp.delivery.did.avp.tech",
						"vitals": "https://audi-esp.vitals.did.avp.tech"
					}
				},
				{
					"name": "FRA",
					"ending": "fr",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-fra.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-fra.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-fra.delivery.did.avp.tech",
						"vitals": "https://audi-fra.vitals.did.avp.tech"
					}
				},
				{
					"name": "FIN",
					"ending": "fi",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-fin.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-fin.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-fin.delivery.did.avp.tech",
						"vitals": "https://audi-fin.vitals.did.avp.tech"
					}
				},
				{
					"name": "GBR",
					"ending": "gb",
					"currency": "GBP",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-gbr.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-gbr.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-gbr.delivery.did.avp.tech",
						"vitals": "https://audi-gbr.vitals.did.avp.tech"
					}
				},
				{
					"name": "ITA",
					"ending": "it",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-ita.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-ita.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-ita.delivery.did.avp.tech",
						"vitals": "https://audi-ita.vitals.did.avp.tech"
					}
				},
				{
					"name": "LUX",
					"ending": "lu",
					"currency": "€",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-lux.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-lux.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-lux.delivery.did.avp.tech",
						"vitals": "https://audi-lux.vitals.did.avp.tech"
					}
				},
				{
					"name": "MEX",
					"ending": "mx",
					"currency": "MXN",
					"currency_previous": "$",
					"currency_after": " MXN",
					"currency_decimal_positions": 2,
					"currency_grouping_separator": ",",
					"currency_decimal_separator": ".",
					"currency_show_digit_grouping": true,
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-mex.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-mex.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-mex.delivery.did.avp.tech",
						"vitals": "https://audi-mex.vitals.did.avp.tech"
					}
				},
				{
					"name": "NLD",
					"ending": "nl",
					"currency": "€",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-nld.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-nld.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-nld.delivery.did.avp.tech",
						"vitals": "https://audi-nld.vitals.did.avp.tech"
					}
				},
				{
					"name": "POL",
					"ending": "pl",
					"currency": "PLN",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-pol.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-pol.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-pol.delivery.did.avp.tech",
						"vitals": "https://audi-pol.vitals.did.avp.tech"
					}
				},
				{
					"name": "USA",
					"ending": "us",
					"currency": "USD",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-usa.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-usa.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-usa.delivery.did.avp.tech",
						"vitals": "https://audi-usa.vitals.did.avp.tech"
					}
				},
				{
					"name": "CHN",
					"ending": "cn",
					"currency": "CNY",
					"nedc": false,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.audi-chn.content.did.avp.tech",
					"urls": {
						"pairing": "https://audi-chn.dealer.did.avp.tech/ssp",
						"delivery": "https://audi-chn.delivery.did.avp.tech",
						"vitals": "https://audi-chn.vitals.did.avp.tech"
					}
				}
			]
		},
		{
			"name": "bentley",
			"markets": [
				{
					"name": "DEU",
					"ending": "de",
					"currency": "EUR",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.bentley-deu.content.did.avp.tech",
					"urls": {
						"pairing": "https://bentley-deu.dealer.did.avp.tech/ssp",
						"delivery": "https://bentley-deu.delivery.did.avp.tech",
						"vitals": "https://bentley-deu.vitals.did.avp.tech"
					}
				},
				{
					"name": "GBR",
					"ending": "gb",
					"currency": "GBP",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://qs.bentley-gbr.content.did.avp.tech",
					"urls": {
						"pairing": "https://bentley-gbr.dealer.did.avp.tech/ssp",
						"delivery": "https://bentley-gbr.delivery.did.avp.tech",
						"vitals": "https://bentley-gbr.vitals.did.avp.tech"
					}
				}
			]
		}
	]
}
